import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';

const API_URL = import.meta.env.VITE_API_URL;

// GET all garden designs for a specific userId
export const getDesignsByUser = async (userId) => {
  try {
    console.log("userId = ", userId)
    const response = await axios.get(`${API_URL}/designs`, { params: { userId } });
    console.log("getDesignsByUser, full response = ", JSON.stringify(response))
    return response.data ?? [];
  } catch (error) {
    console.error('Error fetching designs:', error);
    throw error;
  }
};

// GET Specific Garden Design
export const getSpecificDesign = async (designId) => {
  try {
    const response = await axios.get(`${API_URL}/designs/${designId}`);
    console.log("getSpecificDesign, full response = ", JSON.stringify(response))
    return response.data;
  } catch (error) {
    console.log('Error fetching designs:', error);
    throw error;
  }
};

// POST Garden Design
export const saveDesign = async ({
  userId,
  designName,
  zone,
  style,
  sunlight,
  windows,
  facade,
  houseSize,
  shape,
  bedSize,
  bedConfig,
  chosenPlants,
  designId = uuidv4(),
}) => {

  // Construct the designData object
  const designData = {
    userId,
    designId,
    designName,
    zone,
    style,
    sunlight,
    windows,
    facade,
    houseSize,
    shape,
    bedSize,
    bedConfig,
    chosenPlants,
  };
  try {
    const response = await axios.post(`${API_URL}/designs`, designData, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error saving design:', error);
    throw error;
  }
};


// // UPDATE Garden Design
// export const updateDesign = async (userId, designId, updateDesign) => {
//   try {
//     const response = await axios.put(`${API_URL}/designs/${designId}/update`, {
//       userId,
//       designId,
//       updateDesign,
//     });
//     return response.data;
//   } catch (error) {
//     console.error('Error updating design:', error);
//     throw error;
//   }
// };

// DELETE Garden Design
export const deleteDesign = async (userId, designId) => {
  try {
    const response = await axios.delete(`${API_URL}/designs/${designId}`, {
      params: { userId }
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting design:', error);
    throw error;
  }
};
